import { useGetCustomersList } from '@shared/api/hooks/sold-goods/customers';
import { FormProps } from '@shared/components/form/types';
import { MultiSelect } from '@shared/components/multi-select';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@shared/components/ui/form';
import { cn } from '@shared/lib/utils';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

interface MultiCustomersPickerProps extends FormProps {}

function MultiCustomersPicker({
  name,
  className,
  label,
  includeErrorMessage,
}: MultiCustomersPickerProps) {
  const { control } = useFormContext();

  const { data: customers, isLoading: isCustomersLoading } =
    useGetCustomersList();

  const formattedCustomers = useMemo(() => {
    if (!customers) return [];
    return customers.map((customer) => ({
      label: customer.name,
      value: customer.uuid,
    }));
  }, [customers]);

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormItem className={cn('grid flex-1 items-center', className)}>
            {label && <FormLabel>{label}</FormLabel>}
            <FormControl>
              <MultiSelect
                options={formattedCustomers}
                itemName="customer"
                isLoading={isCustomersLoading}
                onValueChange={field.onChange}
                defaultValue={field.value}
                placeholder={
                  formattedCustomers.length > 0
                    ? 'All customers included'
                    : 'No customers added'
                }
                disabled={formattedCustomers.length === 0}
                className="bg-gray-00"
                autoSize
                responsive
                hideSelectAll
                popoverClassName="max-w-sm"
              />
            </FormControl>
            {includeErrorMessage && <FormMessage />}
          </FormItem>
        );
      }}
    />
  );
}

export default MultiCustomersPicker;
